import React from 'react';
import { DownloadIcon, FileTextIcon, ShieldIcon } from 'lucide-react';
export const BottomSection = () => {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-4 mb-6" data-id="element-59">
      <div className="flex flex-wrap justify-between items-center gap-3" data-id="element-60">
        <div className="flex flex-wrap items-center gap-2" data-id="element-61">
          <button className="border border-gray-300 rounded-md px-3 py-1.5 text-sm flex items-center gap-1 hover:bg-gray-50 whitespace-nowrap" data-id="element-62">
            <DownloadIcon size={14} className="flex-shrink-0" data-id="element-63" />
            <span data-id="element-64">CSV</span>
          </button>
          <button className="border border-gray-300 rounded-md px-3 py-1.5 text-sm flex items-center gap-1 hover:bg-gray-50 whitespace-nowrap" data-id="element-65">
            <DownloadIcon size={14} className="flex-shrink-0" data-id="element-66" />
            <span data-id="element-67">PNG</span>
          </button>
          <button className="border border-gray-300 rounded-md px-3 py-1.5 text-sm flex items-center gap-1 hover:bg-gray-50 whitespace-nowrap" data-id="element-68">
            <FileTextIcon size={14} className="flex-shrink-0" data-id="element-69" />
            <span data-id="element-70">Send til CRM</span>
          </button>
        </div>
        <div className="flex items-start gap-1 text-xs text-gray-500" data-id="element-71">
          <ShieldIcon size={14} className="flex-shrink-0 mt-0.5" data-id="element-72" />
          <span className="line-clamp-2" data-id="element-73">
            Data anvendes til tilbudsopfølgning; ingen følsomme data;
            anonymiseret heatmap.
          </span>
        </div>
      </div>
    </div>;
};